import { directusApi } from '@/api';
import { Data } from '@/models/data.model';
import lodash from 'lodash';
export interface ProductSector {
    id?: number;
    slug: string;
    name: string;
}

export interface ProductSectorState {
    allProductSectors: Array<ProductSector>;
    allProductSectorsLoading: boolean;

    activeProductSector: ProductSector | null;
    activeProductSectorLoading: boolean;
}

const state: ProductSectorState = {
    allProductSectors: [],
    allProductSectorsLoading: false,

    activeProductSector: {
        id: 0,
        slug: '',
        name: ''
    },
    activeProductSectorLoading : false
};

const defaultProductSector = {
    id: 0,
    slug: '',
    name: ''
}

const mutations = {
    TOGGLE_ALL_SECTORS_LOADING(state: ProductSectorState, data: boolean) {
        state.allProductSectorsLoading = data;
    },
    SET_ALL_SECTORS(state: ProductSectorState, data: Array<ProductSector>) {
        state.allProductSectors = data;
    },
    TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING(state: ProductSectorState, data: boolean){
        state.activeProductSectorLoading = data;
    },
    REMOVE_PRODUCT_SECTOR(state: ProductSectorState, id: number) {
        state.allProductSectors = lodash.remove(state.allProductSectors, function (n) {
            return n.id != id;
        });
    },
    SET_ACTIVE_PRODUCT_SECTOR(state: ProductSectorState, data: ProductSector){
        state.activeProductSector = {...data};
    }
};

const actions = {
    async getAll({ _, commit }: any, data: Data | null) {
        let params = '';
        if (data) params += `&search=${data.search}`;
        params += '&limit=200&meta=total_count&sort=name';
        commit('TOGGLE_ALL_SECTORS_LOADING', true);
        await directusApi('GET', `items/products_sectors?${params}`)
            .then(res => {
                commit('SET_ALL_SECTORS', res.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALL_SECTORS_LOADING', false);
            });
    },
    async getOne({ _, commit }: any, id: any | null = null) {
        commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', true);
        if (id) {
            await directusApi('GET', `items/products_sectors/${id}`)
            .then(res => {
                commit('SET_ACTIVE_PRODUCT_SECTOR', res.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', false);
            });   
        } else {
            commit('SET_ACTIVE_PRODUCT_SECTOR', defaultProductSector);
            commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', false);
        }
    },
    async postOne({ _, commit }: any, data: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', true);
        await directusApi('POST', `items/products_sectors`, {
            name: data.data.name,
            slug: data.data.slug
        })
        .then(async (sector: any) => {
            data.vm.$bvToast.toast('Se ha creado exitosamente', {
                title: `Sector creado`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            commit('SET_ACTIVE_PRODUCT_SECTOR', sector.data.data);
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', false);
        });
    },
    async putOne({ _, commit }: any, data: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', true);
        await directusApi('PATCH', `items/products_sectors/${data.data.id}`, {
            name: data.data.name,
            slug: data.data.slug
        })
        .then(async (sector: any) => {
            data.vm.$bvToast.toast('Se ha actualizado exitosamente', {
                title: `Sector actualizado`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            commit('SET_ACTIVE_PRODUCT_SECTOR', sector.data.data);
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', false);
        });
    },
    async deleteOne({ _, commit }: any, data: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', true);
        await directusApi('DELETE', `items/products_sectors/${data.id}`, {})
        .then(async (res: any) => {
            data.vm.$bvToast.toast('Se ha eliminado exitosamente', {
                title: `Sector eliminado`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            commit('REMOVE_PRODUCT_SECTOR', data.id);
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            commit('TOGGLE_ACTIVE_PRODUCT_SECTOR_LOADING', false);
        });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
